var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M34.75,83.4c31,0,48-25.7,48-48,0-.73,0-1.46,0-2.18A34.22,34.22,0,0,0,91.1,24.5a33.6,33.6,0,0,1-9.69,2.65,16.92,16.92,0,0,0,7.42-9.32,33.76,33.76,0,0,1-10.71,4.09A16.88,16.88,0,0,0,49.38,37.3,47.92,47.92,0,0,1,14.62,19.68a16.94,16.94,0,0,0,5.22,22.51,16.69,16.69,0,0,1-7.65-2.11v.22A16.93,16.93,0,0,0,25.72,56.83a16.91,16.91,0,0,1-7.62.29A16.93,16.93,0,0,0,33.86,68.83a33.92,33.92,0,0,1-25,7,47.76,47.76,0,0,0,25.85,7.56"}));
}

Twitter.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 100 100"};

module.exports = Twitter;

Twitter.default = Twitter;
